import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { useDispatch, useSelector } from "react-redux";
import { LabelHeading } from "../../component/LabelHeader/labelHeader.style";
import TableComponent from "../../component/Tables/tableComponent";
import { Container } from "../global/global.style";
import AddNewAlert from "./addNewAlert";
import DeletePopUp from "../../component/deletePopUp/deletePopUp";
import { deleteAlert, getAlerts } from "../../redux/alert/alert.action";
import { useParams } from "react-router-dom";

function Alerts() {
  const dispatch = useDispatch()
  const { dataAssetId } = useParams();
  const { apiData, formData } = useSelector((state) => state.alert);
  const [pagination, setPagination] = useState({
    first: 0,
    rows: 15,
  });
  const [alerts, setAlerts] = useState([]);
  const [showAddAlert, setShowAddAlert] = useState(false);
  const [alertToEdit, setAlertToEdit] = useState(null); // For editing
  const [showDeletePopUp, setShowDeletePopUp] = useState(false);
  const [alertToDelete, setAlertToDelete] = useState(null);



  const handlePageChange = (e) => {
    setPagination({
      first: e.first,
      rows: e.rows,
    });
  };

  const handleEdit = (index) => {
    setAlertToEdit(alerts[index]);
    setShowAddAlert(true);
  };

  const handleDelete = (rowData) => {
    setAlertToDelete(rowData.alert_id);
    setShowDeletePopUp(true);
  };

  const handleAddAlert = (newAlert) => {
    setAlerts((prevAlerts) => {
      if (alertToEdit) {
        return prevAlerts.map(alert =>
          alert.alert_id === newAlert.alert_id ? newAlert : alert
        );
      } else {
        return [...prevAlerts, newAlert];
      }
    });
    setAlertToEdit(null);
  };

  const handleDeleteAlert = () => {
    // setAlerts(alerts.filter(alert => alert.alert_id !== alertToDelete.alert_id));
    dispatch(deleteAlert(alertToDelete,dataAssetId))
    setShowDeletePopUp(false);
  };

  const handleHideAddAlert = () => {
    setShowAddAlert(false);
    setAlertToEdit(null);
  };
  const actionTemplete = (rowData) => {
    return <div style={{ display: "flex" }}>

      <Button onClick={(e) => {
        setAlertToEdit(rowData)
        setShowAddAlert(true)
      }
      } style={{ paddingTop: "17px", color: "#000000B2", backgroundColor: "transparent", border: "none" }} icon="pi pi-pencil" />
      <Button style={{ paddingTop: "17px", color: "#000000B2", backgroundColor: "transparent", border: "none" }} onClick={() => {
        handleDelete(rowData)
      }
      } icon="pi pi-trash" />
    </div>
  }
  const getTableColumn = () => {
    return [
      { field: "alert_id", header: "Alert ID" },
      { field: "alert_type", header: "Alert Type" },
      { field: "alert_config", header: "Info",
        body: (rowData) => (
          <div style={{width:"200px",overflowWrap:"anywhere"}}>
            {rowData.alert_config}
          </div>
        )
       },
      {
        field: "is_active",
        header: "Status",
        style: { width: "22%", overflowWrap: "anywhere" },
        body: (rowData) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                width: "7px",
                height: "7px",
                borderRadius: "50%",
                backgroundColor: rowData.is_active ? "green" : "red",
                marginRight: "5px",
              }}
            ></span>
            {rowData.is_active?"Active":"InActive"}
          </div>
        ),
      },
      { field: "action", header: "Action", body: actionTemplete },
    ]
  }
  useEffect(() => {
    dispatch(getAlerts(dataAssetId))
  }, [])
  return (
    <Container style={{ height: "90%" }}>
      <div className="grid">
        <div className="col-6">
          <LabelHeading>Alerts</LabelHeading>
        </div>
        <div
          className="col-6"
          style={{ display: "inherit", justifyContent: "end" }}
        >
          <div className="col-6" style={{ textAlign: "right" }}>
            <Button
              type="button"
              label="Configure New Alert"
              icon="pi pi-plus-circle"
              iconPos="right"
              style={{ marginRight: "5px", height: "40px" }}
              onClick={() => {
                setAlertToEdit(null)
                setShowAddAlert(true)
              }
              }
            />
          </div>
        </div>
      </div>

      <Panel>
        <TableComponent
          paginator
          rows={pagination.rows}
          first={pagination.first}
          totalRecords={apiData.alertList.data.length}
          onPage={handlePageChange}
          rowsPerPageOptions={[15, 30, 45]}
          virtualScroll
          lazy
          tableData={apiData.alertList.data.slice(pagination.first, pagination.first + pagination.rows)}
          columns={getTableColumn()}
        />
      </Panel>

      {showAddAlert && (
        <AddNewAlert
        dataAssetId={dataAssetId}
          alertToEdit={alertToEdit}
          onHide={handleHideAddAlert}
          onSave={handleAddAlert}
        />
      )}

      {showDeletePopUp && (
        <DeletePopUp
          header="Confirm Deletion"
          message={`Are you sure you want to delete the alert with ID: ${alertToDelete}?`}
          deleteApproved={handleDeleteAlert}
          onHide={() => setShowDeletePopUp(false)}
        />
      )}
    </Container>
  );
}

export default Alerts;
